module.exports = __webpack_public_path__ + "media/images/background/background-dna-9cd0e5587de90381db1f80ff62d0d4a0.svg";